var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFloor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6418_2737",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6418_2737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.85005 7.64998C9.08338 7.41664 9.20005 7.13331 9.20005 6.79998C9.20005 6.46664 9.08338 6.18331 8.85005 5.94998C8.61671 5.71664 8.33338 5.59998 8.00005 5.59998C7.66672 5.59998 7.38338 5.71664 7.15005 5.94998C6.91672 6.18331 6.80005 6.46664 6.80005 6.79998C6.80005 7.13331 6.91672 7.41664 7.15005 7.64998C7.38338 7.88331 7.66672 7.99998 8.00005 7.99998C8.33338 7.99998 8.61671 7.88331 8.85005 7.64998ZM8.00005 14.4C6.2556 12.9444 4.95283 11.5916 4.09172 10.3416C3.2306 9.09164 2.80005 7.92775 2.80005 6.84998C2.80005 5.36109 3.29449 4.11386 4.28338 3.10831C5.27227 2.10275 6.51116 1.59998 8.00005 1.59998C9.47783 1.59998 10.7139 2.10275 11.7084 3.10831C12.7028 4.11386 13.2 5.36109 13.2 6.84998C13.2 7.92775 12.7723 9.08886 11.9167 10.3333C11.0612 11.5778 9.7556 12.9333 8.00005 14.4Z",
    fill: "#B3531B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloor);
export default __webpack_public_path__ + "static/media/floor.a59528e2b48fb2afb873df8bfbfc9a2d.svg";
export { ForwardRef as ReactComponent };